import { render } from "./TabButton.vue?vue&type=template&id=876b323a&scoped=true&ts=true"
import script from "./TabButton.vue?vue&type=script&lang=ts"
export * from "./TabButton.vue?vue&type=script&lang=ts"

import "./TabButton.vue?vue&type=style&index=0&id=876b323a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-876b323a"]])

export default __exports__